/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { Contract } from './Contract.js'
import { CustomerFacingContacts } from './CustomerFacingContacts.js'
import { Finance } from './Finance.js'
import { Happiness } from './Happiness.js'
import { JiraData } from './JiraData.js'
import { Location } from './Location.js'
import { OrganizationPriority } from './OrganizationPriority.js'
import { PrimaryContact } from './PrimaryContact.js'
import { ProductEntitlement } from './ProductEntitlement.js'
import { Projection } from './Projection.js'
import { SlackChannel } from './SlackChannel.js'

export const OrganizationResponse = z.object({
  accountManager: z.string(),
  archivedAt: z.string().nullish(),
  confluenceURL: z.string(),
  contracts: z.array(Contract),
  createdAt: z.string(),
  deliveryManager: CustomerFacingContacts,
  executiveSponsor: CustomerFacingContacts,
  finance: Finance,
  flags: z.record(z.boolean()).nullish(),
  groupContacts: z.array(z.string()),
  happiness: Happiness,
  hubSpotId: z.string(),
  id: z.string(),
  isStarter: z.boolean(),
  isTestData: z.boolean(),
  isTransitioningFromHubSpot: z.boolean(),
  jira: JiraData,
  location: Location,
  name: z.string(),
  onboardingDate: z.string(),
  organizationPriority: OrganizationPriority,
  partners: z.array(z.string()),
  primaryContacts: z.array(PrimaryContact),
  productEntitlements: z.array(ProductEntitlement),
  productsActive: z.array(z.string()),
  projection: Projection,
  retentionStatus: z.string(),
  services: z.array(z.string()),
  slackChannel: SlackChannel,
  slug: z.string(),
  slugAlias: z.string(),
  solutionArchitect: CustomerFacingContacts,
  status: z.enum(['IN_EVALUATION', 'ACTIVE', 'DORMANT', 'CHURNED']),
  studios: z.array(z.string()),
  timezone: z.string(),
  type: z.enum(['STUDIO', 'PUBLISHER']),
  updatedAt: z.string()
})

export interface OrganizationResponse extends z.TypeOf<typeof OrganizationResponse> {}
